import { render } from "./NavbarMobile.vue?vue&type=template&id=589b8560&scoped=true"
import script from "./NavbarMobile.vue?vue&type=script&lang=js"
export * from "./NavbarMobile.vue?vue&type=script&lang=js"

import "./NavbarMobile.vue?vue&type=style&index=0&id=589b8560&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-589b8560"

export default script